import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {AjaxService} from 'AjaxService';
import {DxPopupComponent} from 'devextreme-angular/ui/popup';
import {DxTextBoxComponent} from 'devextreme-angular/ui/text-box';
import {ModalService} from 'ModalService';

@Component({
    selector: 'app-del-admin',
    templateUrl: './del-admin.component.html',
    styleUrls: ['./del-admin.component.css'],
    standalone: false
})
export class DelAdminComponent implements OnInit, OnDestroy {
  @ViewChild('popup', {static: false}) popup: DxPopupComponent;
  @ViewChild('confirmPopup', {static: false}) confirmPopup: DxPopupComponent;
  @ViewChild('confirmTextBox', {static: false}) confirmTextBox: DxTextBoxComponent;

  id: string = 'modal-del-admin';
  loading: boolean = true;
  deleting: boolean = false;
  isConfirmValid: boolean = true;
  context: any;
  datas: any[] = [];
  confirmText: string = '';

  constructor(private modalService: ModalService, private ajaxService: AjaxService) {
    this.onClickDel = this.onClickDel.bind(this);
    this.onClickClose = this.onClickClose.bind(this);
    this.onConfirmClickOk = this.onConfirmClickOk.bind(this);
    this.onConfirmClickClose = this.onConfirmClickClose.bind(this);
  }

  ngOnInit(): void {
    this.modalService.add(this);
  }

  ngOnDestroy(): void {
    this.modalService.remove(this.id);
  }

  open(context: any) {
    this.context = context;
    this.deleting = false;

    this.popup.instance.show().then(() => {
      this.load();
    });
  }

  onInitialized(e: any) {
    e.component.registerKeyHandler('escape', (arg: any) => {
      arg.stopPropagation();
    });
  }

  onHidden(e: any) {
    this.loading = true;
    this.context = null;
    this.datas = [];
  }

  load() {
    this.loading = true;
    this.ajaxService.post<any[]>('api/Del/Get', this.context.datas).subscribe({
      next: (response) => {
        this.datas = response;
        this.loading = false;
      },
      error: (err) => {
        this.loading = false;
        throw err;
      },
    });
  }

  onClickDel(e: any) {
    this.confirmText = '';
    this.isConfirmValid = true;
    this.confirmPopup.instance.show();
  }

  del() {
    this.deleting = true;
    if (this.context !== undefined && this.context !== null) {
      this.ajaxService.post<any[]>('api/Del/Remove', this.context.datas).subscribe({
        next: (response) => {
          if (this.context.cbOk !== undefined && this.context.cbOk !== null) {
            this.context.cbOk();
            this.popup.instance.hide();
          } else {
            this.popup.instance.hide();
          }
        },
        error: (err) => {
          this.deleting = false;
          throw err;
        },
      });
    }
  }

  onClickClose(e: any) {
    this.popup.instance.hide();
  }

  //------------

  onConfirmClickOk(e: any) {
    if (this.confirmTextBox.value === 'LÖSCHEN') {
      this.confirmPopup.instance.hide().then(() => {
        this.del();
      });
    } else {
      this.isConfirmValid = false;
      this.confirmText = '';
    }
  }

  onConfirmClickClose(e: any) {
    this.confirmPopup.instance.hide();
  }
}
